import Links from '@/shared/constants/navegacao';
import { ApiReturn } from '@/modules/api.service';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { Fragment, useEffect, useState } from 'react';
import { LerTipoMovimentacoes } from '@/modules/business/movimentacoes_tipos/movimentacaotipo.service';
import { Link } from 'react-router-dom';
import { ReadMovimentacaoTipoDto } from '@/api.types';
import { MovimentacaoTipoPDF } from '@/modules/business/movimentacoes_tipos/pages/ReportPage';
import { exportFromJsxToPdf } from '@/shared/utils/pdf';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';

export default function MovimentacaoTipoIndex() {
  const { setActions } = useBreadcrumbActions();
  const [ehNucleo, setEhNucleo] = useState(false);
  const [registros, setRegistros] = useState<ApiReturn<ReadMovimentacaoTipoDto>>({ objects: [], count: 0, });
  const tableState = useDataTableState('descricao');

  const handleBuscar = () => {
    LerTipoMovimentacoes(
      (tableState.currentPage - 1) * tableState.pageSize,
      tableState.pageSize,
      ehNucleo,
    )
      .then((result) => {
        setRegistros(result);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  }

  useEffect(() => {
    handleBuscar();
  }, [ehNucleo]);

  const handleGerarPDF = async () => {
    try {
      const registrosDefensoria = await LerTipoMovimentacoes(0, 10000, false);
      const registrosNucleo = await LerTipoMovimentacoes(0, 10000, true);

      const todosRegistros = {
        objects: [
          ...registrosDefensoria.objects.map((item: any) => ({ ...item, ehNucleo: false })),
          ...registrosNucleo.objects.map((item: any) => ({ ...item, ehNucleo: true }))
        ],
        count: registrosDefensoria.count + registrosNucleo.count
      };

      exportFromJsxToPdf(
        <MovimentacaoTipoPDF registros={todosRegistros} />
      );
    } catch (error) {
      toast.error('Erro ao gerar PDF: ' + (error as Error).message);
    }
  };

  useEffect(() => {
    setActions({
      primary: { label: 'Cadastrar', href: Links.Movimentacoes_Tipos_Criar, onClick: () => { } },
      print: { label: 'Imprimir', onClick: () => handleGerarPDF() },
    });
    return () => setActions({});
  }, [setActions]);

  let colunas: Column<ReadMovimentacaoTipoDto>[] = [
    {
      key: "inicial", header: "Petição Inicial",
      render: (row) => {
        return (<>{<input
          type="checkbox"
          checked={row.inicial}
          readOnly={true}
        ></input>}</>)
      }
    },
    { key: "descricao", header: "Descrição" },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Movimentacoes_Tipos_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <h3 className="mb-0">Tipos de Movimentações</h3>
          <span className="blockquote-footer text-end">
            Tipos de Movimentações
          </span>
        </div>
        <hr className="pb-4" />

        {registros &&
          <DataTable
            columns={colunas}
            data={registros.objects}
            initialSortKey='descricao'
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros.count}
            renderFilters={() => (
              <div className="col-auto form-check mt-4" title="Exibir Núcleos.">
                <input
                  id="nucleo"
                  className="form-check-input"
                  type="checkbox"
                  checked={ehNucleo}
                  onChange={(e) => {
                    setEhNucleo(e.target.checked);
                  }} />
                <label htmlFor="nucleo" className="form-check-label">
                  Núcleos
                </label>
              </div>
            )}
          />
        }
      </div>
    </Fragment>
  );
}
